import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../../../../app/store";
import axiosInstance from "../../../../../../configs/axios/axios ";
import {
  RENAME_FILE,
  RENAME_FOLDER,
} from "../../../../../../configs/axios/constantsAPI";
import {
  getDirectoryAction,
  searchDirectoryAction,
} from "../../../directory/directorySlice";
import { getShareManagementListAction } from "../../../../share-management/shareManagementSlice";
import { getCookie } from "../../../../../../configs/cookie-helper/cookieHelper";

export const renameFileAction = createAsyncThunk(
  "drawerInfo/renameFile",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        RENAME_FILE,
        {
          id: getState().directoryItemsState.itemInfo.id,
          file_name: getState().directoryItemsState.itemInfo.name,
          name: sendData.name,
          type: sendData.type,
          path: getState().directoryItemsState.itemInfo.path,
        },
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      dispatch(
        getDirectoryAction({
          path: getState().directoryState.directoryData.path,
          idfolder: getState().directoryState.directoryData.idfolder,
        })
      );

      dispatch(
        getShareManagementListAction({
          file_id: getState().directoryItemsState.itemInfo.id,
        })
      );

      if (getState().directoryState.searchInput !== "") {
        dispatch(
          searchDirectoryAction({
            path: getState().directoryState.directoryData.path,
            name: getState().directoryState.searchInput,
            dir: "true",
          })
        );
      }

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const renameFolderAction = createAsyncThunk(
  "drawerInfo/renameFolder",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        RENAME_FOLDER,
        {
          idfolder: getState().directoryItemsState.itemInfo.id,
          name: sendData.name,
          path: getState().directoryItemsState.itemInfo.path,
        },
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      dispatch(
        getDirectoryAction({
          path: getState().directoryState.directoryData.path,
          idfolder: getState().directoryState.directoryData.idfolder,
        })
      );

      dispatch(
        getShareManagementListAction({
          file_id: getState().directoryItemsState.itemInfo.id,
        })
      );

      if (getState().directoryState.searchInput !== "") {
        dispatch(
          searchDirectoryAction({
            path: getState().directoryState.directoryData.path,
            name: getState().directoryState.searchInput,
            dir: "true",
          })
        );
      }

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export interface DrawerInfoState {
  renameData: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
    newName: string;
  };
}

const initialState: DrawerInfoState = {
  renameData: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
    newName: "",
  },
};

export const drawerInfoSlice = createSlice({
  name: "drawerInfo",
  initialState,
  reducers: {
    resetRenameStatusAction: (state) => {
      state.renameData = {
        ...state.renameData,
        actionStatus: "",
        alert: {
          error: false,
          message: "",
        },
      };
    },
    resetRenameAction: (state) => {
      state.renameData = initialState.renameData
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(renameFileAction.pending, (state) => {
      state.renameData.actionStatus = "loading";
      state.renameData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(renameFileAction.fulfilled, (state, { payload }) => {
      state.renameData.actionStatus = "success";
      state.renameData.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
      state.renameData.newName = !!payload.content.type
        ? `${payload.content.name}.${payload.content.type}`
        : payload.content.name;
    });
    addCase(renameFileAction.rejected, (state, { payload }: any) => {
      state.renameData.actionStatus = "rejected";
      state.renameData.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });

    addCase(renameFolderAction.pending, (state) => {
      state.renameData.actionStatus = "loading";
      state.renameData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(renameFolderAction.fulfilled, (state, { payload }) => {
      state.renameData.actionStatus = "success";
      state.renameData.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
      state.renameData.newName = payload.content.namefolder;
    });
    addCase(renameFolderAction.rejected, (state, { payload }: any) => {
      state.renameData.actionStatus = "rejected";
      state.renameData.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });
  },
});

export const { resetRenameStatusAction, resetRenameAction } =
  drawerInfoSlice.actions;

export const drawerInfo = (state: RootState) => state.drawerInfoState;

export default drawerInfoSlice.reducer;
